'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestionMarkCircled;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function QuestionMarkCircled(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-question-mark-circled ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: color, fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M11.452 6.226c0 .58-.172 1.075-.517 1.484-.215.236-.57.494-1.064.774-.258.15-.43.269-.516.355-.15.107-.226.236-.226.387v.193a.373.373 0 0 1-.113.275.373.373 0 0 1-.274.112H7.258a.373.373 0 0 1-.274-.112.373.373 0 0 1-.113-.275v-.29c0-.495.172-.914.516-1.258.194-.194.516-.42.968-.677l.064-.033c.323-.193.549-.344.678-.451a.71.71 0 0 0 .226-.516c0-.259-.135-.474-.404-.646a1.64 1.64 0 0 0-.903-.258 1.56 1.56 0 0 0-.855.226c-.193.13-.43.376-.71.742a.481.481 0 0 1-.241.13.323.323 0 0 1-.275-.065l-.903-.678a.353.353 0 0 1-.145-.258.52.52 0 0 1 .048-.29c.41-.58.871-1.016 1.388-1.307.516-.29 1.14-.435 1.87-.435.517 0 1.033.129 1.549.387s.93.602 1.242 1.032c.312.43.468.914.468 1.452zm-2.097 5.387c0 .365-.135.683-.403.952a1.301 1.301 0 0 1-.952.403c-.366 0-.683-.135-.952-.403a1.301 1.301 0 0 1-.403-.952c0-.366.135-.683.403-.952.27-.269.586-.403.952-.403s.683.134.952.403c.268.27.403.586.403.952z' }),
      _react2.default.createElement('path', { fillRule: 'nonzero', d: 'M16 8a7.76 7.76 0 0 1-1.08 4A8.084 8.084 0 0 1 12 14.92 7.76 7.76 0 0 1 8 16a7.76 7.76 0 0 1-4-1.08A8.084 8.084 0 0 1 1.08 12 7.76 7.76 0 0 1 0 8c0-1.44.36-2.774 1.08-4A8.084 8.084 0 0 1 4 1.08 7.76 7.76 0 0 1 8 0c1.44 0 2.773.36 4 1.08A8.084 8.084 0 0 1 14.919 4 7.76 7.76 0 0 1 16 8zM1.549 8c0 1.161.29 2.237.87 3.226a6.504 6.504 0 0 0 2.355 2.355 6.26 6.26 0 0 0 3.227.87 6.26 6.26 0 0 0 3.225-.87 6.504 6.504 0 0 0 2.355-2.355A6.26 6.26 0 0 0 14.45 8a6.26 6.26 0 0 0-.87-3.226 6.504 6.504 0 0 0-2.355-2.355A6.26 6.26 0 0 0 8 1.55a6.26 6.26 0 0 0-3.226.87 6.504 6.504 0 0 0-2.355 2.355A6.26 6.26 0 0 0 1.55 8z' })
    )
  );
}

QuestionMarkCircled.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/QuestionMarkCircled/QuestionMarkCircled.js
// module id = 293
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15